import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { XCircle, ShoppingCart } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-[#F4F6F4] flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <Card className="max-w-md w-full p-8 border border-gray-200 shadow-none rounded-lg text-center space-y-4">
        <XCircle className="w-12 h-12 mx-auto text-amber-600" />
        <h1 className="font-display text-2xl text-brand-ink">Pago cancelado</h1>
        <p className="text-sm text-gray-500">
          No se ha realizado ningún cobro. Tu carrito sigue disponible por si quieres reintentarlo.
        </p>
        <Link to="/">
          <Button className="bg-brand hover:bg-brand-hover text-white" data-testid="back-to-catalog-btn">
            <ShoppingCart className="w-4 h-4 mr-2" />
            Volver al catálogo
          </Button>
        </Link>
      </Card>
    </div>
  );
}
